import { BaseService } from "./base.service";
export class NewsCategoriesService extends BaseService {
  constructor() {
    super("news-categories");
  }
}
